import { motion } from "framer-motion";

const DRI_MODULES = [
  {
    icon: "public",
    title: "Dark & Deep Web",
    desc: "Continuous monitoring of underground forums, ransomware leak sites, and deep web marketplaces for mentions of your brand or stolen assets.",
  },
  {
    icon: "phishing",
    title: "Phishing Infrastructure",
    desc: "Early detection of newly registered typosquat domains, rogue MX records, and staged phishing kits impersonating your services.",
  },
  {
    icon: "groups",
    title: "Social Media Monitoring",
    desc: "Identify executive impersonations, fake brand profiles, and coordinated disinformation campaigns targeting your organization.",
  },
  {
    icon: "policy",
    title: "Data Leak Detection",
    desc: "Rapid identification of exposed internal documents, source code, and customer data across public repositories and paste sites.",
  },
];

const LEAK_TYPES = [
  { icon: "key", label: "Credentials & Access Tokens" },
  { icon: "badge", label: "PII (Personally Identifiable Info)" },
  { icon: "credit_card", label: "Financial & Payment Data" },
  { icon: "code", label: "Proprietary & Source Code" },
  { icon: "terminal", label: "Software & Dev Tools" },
  { icon: "cloud", label: "Cloud & Infrastructure Leaks" },
];

export default function DigitalRiskSection() {
  return (
    <>
      <section className="mb-section-gap">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-stack-lg"
        >
          <span className="font-eyebrow text-eyebrow text-secondary uppercase tracking-widest block mb-4">
            Core Capabilities
          </span>
          <h2 className="font-headline-section text-headline-section text-on-surface dark:text-surface-bright">
            Digital Risk Modules
          </h2>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-gutter mt-12">
          {DRI_MODULES.map((m, i) => (
            <motion.div
              key={m.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="bg-surface-card-light dark:bg-surface-card-dark backdrop-blur-lg border border-glass rounded-2xl p-card-padding relative overflow-hidden shadow-sm hover:-translate-y-1 transition-transform group"
            >
              <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-secondary to-transparent opacity-50 group-hover:opacity-100 transition-opacity" />
              <div className="w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center mb-6">
                <span className="material-symbols-outlined text-secondary">{m.icon}</span>
              </div>
              <h3 className="font-headline-card text-headline-card text-on-surface dark:text-surface-bright mb-2">
                {m.title}
              </h3>
              <p className="font-body-md text-body-md text-on-surface-variant dark:text-surface-variant">
                {m.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="mb-section-gap">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5 }}
          className="mb-stack-lg"
        >
          <span className="font-eyebrow text-eyebrow text-secondary uppercase tracking-widest block mb-4">
            Coverage
          </span>
          <h2 className="font-headline-section text-headline-section text-on-surface dark:text-surface-bright">
            Data Leak Types We Detect
          </h2>
        </motion.div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-8">
          {LEAK_TYPES.map((item, i) => (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.35, delay: i * 0.05 }}
              className="bg-surface-bright dark:bg-white/5 border border-glass rounded-xl p-6 flex flex-col items-start gap-4 shadow-sm hover:shadow-md transition-shadow"
            >
              <span className="material-symbols-outlined text-secondary" style={{ fontVariationSettings: "'FILL' 1" }}>
                {item.icon}
              </span>
              <h4 className="font-headline-card text-sm md:text-base text-on-surface dark:text-surface-bright">
                {item.label}
              </h4>
            </motion.div>
          ))}
        </div>
      </section>
    </>
  );
}
